"use strict";
var Observable_1 = require('../Observable');
var NeverObservable_1 = require('./NeverObservable');
var noop_1 = require('../util/noop');
/**
 * An Observable that emits no items to the Observer and never completes. Compatible with
 * RxJS v6 API.
 *
 * <img src="./img/never.png" width="100%">
 *
 * A simple Observable that emits neither values nor errors nor the completion
 * notification. It can be used for testing purposes or for composing with other
 * Observables. Please note that by never emitting a complete notification, this
 * Observable keeps the subscription from being disposed automatically.
 * Subscriptions need to be manually disposed.
 *
 * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
 * function info() {
 *   console.log('Will not be called');
 * }
 * var result = NEVER.startWith(7);
 * result.subscribe(x => console.log(x), info, info);
 *
 * @see {@link create}
 * @see {@link EMPTY}
 * @see {@link of}
 * @see {@link throwError}
 */
exports.NEVER = new Observable_1.Observable(noop_1.noop);
exports.never = NeverObservable_1.NeverObservable.create;
//# sourceMappingURL=never.js.map